module.exports = __webpack_public_path__ + "static/assets/a832d077dcd73b4ec6f68a2e0278fa7e.png";